import { createArtworkUpload, setDraftArtwork, storeArtwork } from "./artwork";
import {
  beginDraft,
  create,
  discardDraft,
  getEditing,
  getSlug,
  listMine,
  publishDraft,
  setArchived,
  setDraftVersionNumber,
  setLiveVersion,
  setPrimaryDraft,
  setTitle,
} from "./authoring";
import { get, getFile, getVersion, list, listTags } from "./endpoints";
import { getShares, moveShares } from "./shares";
import { getStats } from "./stats";
import {
  acceptInvitation,
  createRole,
  declineInvitation,
  deleteRole,
  getTeam,
  invite,
  listTeamEvents,
  removeMember,
  transferOwnership,
  updateMember,
  updateRole,
} from "./team";

export {
  ARTWORK_KINDS,
  ARTWORK_UPLOAD_CONTENT_TYPES,
  ARTWORK_UPLOAD_MAX_BYTES,
  ArtworkKind,
  CreateArtworkUploadRequest,
  CreateArtworkUploadResponse,
  createArtworkUpload,
  DraftArtworkParams,
  SetDraftArtworkRequest,
  StoreArtworkRequest,
  StoredArtwork,
  setDraftArtwork,
  storeArtwork,
} from "./artwork";
export {
  BeginDraftRequest,
  beginDraft,
  CreatePresetRequest,
  CreatePresetResponse,
  create,
  DraftPage,
  DraftParams,
  DraftProblem,
  DraftStatus,
  DraftSummary,
  discardDraft,
  GetPresetSlugQuery,
  GetPresetSlugResponse,
  getEditing,
  getSlug,
  ListMyPresetsResponse,
  listMine,
  MyPreset,
  PRESET_TITLE_MAX_CHARACTERS,
  PresetEditing,
  PresetInvitation,
  PresetTitle,
  PublishDraftResponse,
  PublishOutcome,
  publishDraft,
  RESERVED_PRESET_SLUGS,
  SetDraftVersionNumberRequest,
  SetLiveVersionRequest,
  SetPresetArchivedRequest,
  SetPresetTitleRequest,
  SetPrimaryDraftRequest,
  setArchived,
  setDraftVersionNumber,
  setLiveVersion,
  setPrimaryDraft,
  setTitle,
  VersionSummary,
} from "./authoring";
export { PRESET_CATEGORIES, PresetCategory } from "./categories";
export { presetVersionFilePath, presetVersionFileRoute, service } from "./endpoints";
export { noSuchPreset, teamRefusals } from "./refusals";
export {
  ArtworkSet,
  ArtworkTint,
  COPY_PROTECTION_DAYS,
  GetPresetResponse,
  LandingMedia,
  LandingVideo,
  LandingVideoSource,
  ListPresetsQuery,
  ListPresetsResponse,
  ListPresetTagsQuery,
  ListPresetTagsResponse,
  landingVideoSet,
  PRESET_TAG_MAX_CHARACTERS,
  PRESET_TAG_MAX_COUNT,
  PresetAuthor,
  PresetDetail,
  PresetListing,
  PresetSlugParams,
  PresetStorefront,
  PresetTag,
  PresetTagCount,
  PresetTags,
  PresetVersionFileParams,
  PresetVersionParams,
  PresetViewer,
  TimedArtworkTint,
  VERSION_NUMBER_LENGTH,
  VersionNumber,
  WorldDownload,
} from "./schemas";
export { getShares, MoveSharesRequest, moveShares, PresetShares, ShareEntry } from "./shares";
export { getStats, PresetStats, STATS_WEEKS } from "./stats";
export {
  acceptInvitation,
  CreateRoleRequest,
  createRole,
  DEFAULT_PRESET_ROLES,
  DraftTeam,
  declineInvitation,
  deleteRole,
  EVERYONE_RANK,
  EVERYONE_ROLE,
  FIRST_SHARE_SUPPLY,
  getTeam,
  HIGHEST_RANK,
  InviteRequest,
  IssueLimit,
  invite,
  ListTeamEventsQuery,
  ListTeamEventsResponse,
  listTeamEvents,
  PRESET_PERMISSIONS,
  PresetPermission,
  PresetRole,
  PresetRoleId,
  PresetTeam,
  ROLE_NAME_MAX_CHARACTERS,
  removeMember,
  TEAM_EVENT_TYPES,
  TeamEvent,
  TeamMember,
  TransferOwnershipRequest,
  transferOwnership,
  UpdateMemberRequest,
  UpdateRoleRequest,
  updateMember,
  updateRole,
} from "./team";

export const contract = {
  list,
  get,
  tags: { list: listTags },
  versions: {
    get: getVersion,
    files: { get: getFile },
  },
  create,
  slug: { get: getSlug },
  mine: { list: listMine },
  editing: { get: getEditing },
  artwork: {
    create: storeArtwork,
    uploads: { create: createArtworkUpload },
  },
  drafts: {
    artwork: { set: setDraftArtwork },
    create: beginDraft,
    delete: discardDraft,
    publish: publishDraft,
    versionNumber: { set: setDraftVersionNumber },
  },
  title: { set: setTitle },
  archived: { set: setArchived },
  primaryDraft: { set: setPrimaryDraft },
  liveVersion: { set: setLiveVersion },
  team: {
    get: getTeam,
    invitations: { create: invite },
    invitation: { accept: acceptInvitation, delete: declineInvitation },
    members: { update: updateMember, delete: removeMember },
    roles: { create: createRole, update: updateRole, delete: deleteRole },
    owner: { set: transferOwnership },
    events: { list: listTeamEvents },
  },
  shares: { get: getShares, move: moveShares },
  stats: { get: getStats },
} as const;
